<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">大型仪器设备预约</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus1" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增预约</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="device_no" label="设备编号" width="100">
      </custom-table-column>
      <custom-table-column prop="device_name" label="设备名称">
      </custom-table-column>
      <custom-table-column label="审核状态" prop="status" width="150" :formatter="format_status">
      </custom-table-column>
      <custom-table-column prop="start_time" label="开始时间" width="180">
      </custom-table-column>
      <custom-table-column prop="end_time" label="结束时间" width="180">
      </custom-table-column>
      <custom-table-column prop="evaluation" label="评价" min-width="180">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          <el-button v-if="scope.row.status==1" @click="handleOper(scope.row.id)" type="text" size="small">评价</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="大型设备" prop="big_device_id">
          <el-select v-model="ruleForm.big_device_id" filterable style="width:532px;" placeholder="请选择大型设备">
            <el-option v-for="item in $store.state.bigDevices" :key="item.id" :label="item.device_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" v-model="ruleForm.start_time" style="width:206px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" v-model="ruleForm.end_time" style="width:206px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="用途" prop="users">
          <el-input type="textarea" v-model="ruleForm.users" placeholder="请输入用途" style="width:532px;" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="使用样品" prop="samples">
          <div v-for="(item,index) in jsons" :key="index" class="sample_item">
            <el-input v-model="item.name" placeholder="请输入样品名称" style="width:348px;margin-right: 12px;"></el-input>
            <el-input v-model.number="item.num" placeholder="请输入数量" style="width:106px;margin-right: 12px;"></el-input>
            <el-button title="删除一条" @click="handleDeleteItem(index)" icon="el-icon-delete" circle></el-button>
          </div>
          <div>
            <el-button size="mini" @click="handleAddItem">新增一条+</el-button>
          </div>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <!-- <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button> -->
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="operDialogVisible" width="530px">
      <el-form :model="ruleOperForm" ref="ruleOperForm" label-width="100px" class="demo-ruleForm">
        <el-form-item  label="评  价" prop="eva"   :rules="[{ required:true, message: '请输入评价', trigger: 'blur' }]">
          <el-input type="textarea" v-model="ruleOperForm.eva" placeholder="请输入评价"  style="width:352px;" :rows="5"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleOperForm',setStatus)">确认</el-button>
          <el-button @click="resetForm('ruleOperForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList,mixinFormatter],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      props: {
        label: 'name',
      },
      jsons: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        device_name: '',
      },
      ruleOperForm: {
        borrow_id: '',
        eva: '',
      },
      formInline1: {},
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        big_device_id: '',
        users: '',
        start_time: '',
        end_time: '',
        samples: '',
      },
      rules: {
        big_device_id: [{ required: true, message: '请选择大型设备', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        users: [{ required: true, message: '请输入用途', trigger: 'blur' }],
      },
      uploadType: 'image',
      btnTitle: '点击上传警示图标',
      inputValue: '',
      inputVisible: false,
      inputValue1: '',
      inputVisible1: false,
      fileFieldName: 'warning_icons',
      operDialogVisible: false,
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getStandards');
    this.$store.dispatch('getBigDevices');
  },
  watch: {
    jsons: {
      handler: function (val) {
        if(val.length > 0){
          this.ruleForm.samples = JSON.stringify(val)
        }else{
          this.ruleForm.samples = ""
        }
      },
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleOper(id) {
      this.ruleOperForm.borrow_id = id;
      this.operDialogVisible = true;
      this.$nextTick(()=>{
        this.resetForm('ruleOperForm')
      })
    },
    async setStatus() {
      let params = this.$until.deleteNullPrototype(this.ruleOperForm);
      let res = await this.$api.instance.interfaceServer(`api/big/device/eva`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '评价成功！',
        });
        this.operDialogVisible = false;
        this.ruleOperForm = {
          id: '',
          eva: '',
        };
        this.getList();
      }
    },
    handleAddItem() {
      this.jsons.push({ name: '', num: '' });
    },
    handleDeleteItem(index){
      this.jsons.splice(index, 1);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/big/device/borrow/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/big/device/borrow/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/big/device/edit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/big/device/borrow/self/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
.sample_item {
  background: #e5eced;
  padding: 4px 6px;
  border-radius: 5px;
}
.sample_item+.sample_item{
  margin-top: 4px;
}
</style>
